import { Link } from '@/components/ui/Link';
import { useMasterData } from '@/contexts/profile';
import { useFetchBlogQuery } from '@/features/blog/api';
import { PagePath } from '@/layouts/shared';
import React, { memo, useEffect, useState } from 'react';
type BreadcrumbProps = {
  blogId: number;
  title: string;
};
export const Breadcrumb = ({ blogId, title }: BreadcrumbProps) => {
  const masterData = useMasterData();
  const [blog, setBlog] = useState<any>();
  const { refetch } = useFetchBlogQuery(blogId + '', {
    enabled: false,
    refetchOnWindowFocus: false,
    onSuccess: (data) => setBlog(data.data),
  });
  useEffect(() => {
    if (blogId) refetch();
  }, [blogId, refetch]);
  return (
    <>
      {masterData?.menu_blogs && (
        <div className="md:tw-hidden  tw-overflow-x-scroll ">
          <div className={`tw-flex tw-items-center tw-gap-x-8 tw-text-lg md:tw-text-xl tw-uppercase tw-mb-5 tw-w-max`}>
            {masterData?.menu_blogs.map((m: { name: string; slug: string }) => (
              <Link
                key={m.name}
                className={`${
                  blog?.slug === m.slug ? 'tw-font-semibold tw-border-b-[3px] tw-border-primary-main' : ''
                } !tw-text-secondary-70`}
                url={{
                  pathname: PagePath.BlogPage,
                  query: {
                    id: m.slug,
                  },
                }}
              >
                {m.name}
              </Link>
            ))}
          </div>
        </div>
      )}
      <div className="tw-font-regular tw-text-secondary-70 tw-text-base tw-flex tw-items-center">
        <span>Tin tức &nbsp;{'>'}&nbsp;</span>
        <Link url={{ pathname: PagePath.BlogPage, query: { id: blog?.slug } }} className="!tw-text-secondary-70 ">
          {blog?.name}
        </Link>
        &nbsp;{'>'}&nbsp;{' '}
        <span className="tw-flex-1 tw-line-clamp-1" dangerouslySetInnerHTML={{ __html: title }}></span>
      </div>
    </>
  );
};
export const BreadcrumbMobile = ({ blogId, title }: BreadcrumbProps) => {
  const masterData = useMasterData();
  const [blog, setBlog] = useState<any>();
  const { refetch } = useFetchBlogQuery(blogId + '', {
    enabled: false,
    refetchOnWindowFocus: false,
    onSuccess: (data) => setBlog(data.data),
  });
  useEffect(() => {
    if (blogId) refetch();
  }, [blogId, refetch]);
  return (
    <>
      {masterData?.menu_blogs && (
        <div className="md:tw-hidden  tw-overflow-x-scroll ">
          <div className={`tw-flex tw-items-center tw-gap-x-8 tw-text-lg md:tw-text-xl tw-uppercase tw-mb-5  tw-w-max`}>
            {masterData?.menu_blogs.map((m: { name: string; slug: string }) => (
              <Link
                key={m.name}
                className={`${
                  blog?.slug === m.slug ? 'tw-font-semibold tw-border-b-[3px] tw-border-primary-main' : ''
                } !tw-text-secondary-70`}
                url={{
                  pathname: PagePath.BlogMobilePage,
                  query: {
                    id: m.slug,
                  },
                }}
              >
                {m.name}
              </Link>
            ))}
          </div>
        </div>
      )}
      <div className="tw-font-regular tw-text-secondary-70 tw-text-base tw-flex tw-items-center">
        <span>Tin tức &nbsp;{'>'}&nbsp;</span>
        <Link url={{ pathname: PagePath.BlogMobilePage, query: { id: blog?.slug } }} className="!tw-text-secondary-70 ">
          {blog?.name}
        </Link>
        &nbsp;{'>'}&nbsp;{' '}
        <span className="tw-flex-1 tw-line-clamp-1" dangerouslySetInnerHTML={{ __html: title }}></span>
      </div>
    </>
  );
};
